var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row px-5" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end align-items-center" },
          [
            _c(
              "div",
              { staticStyle: { width: "60px", height: "60px" } },
              [
                _vm.paymentPercentage < 100
                  ? _c(
                      "circle-loader",
                      {
                        attrs: {
                          "circle-class": "custom-circle-loader",
                          "has-icon": "",
                          "icon-class": "green-color",
                          percentage: _vm.paymentPercentage
                        }
                      },
                      [
                        _c(
                          "text",
                          {
                            attrs: {
                              fill:
                                _vm.paymentPercentage == 100
                                  ? "background-green #000000"
                                  : "#E5F5EF",
                              "font-family": "Font Awesome\\ 5 Free",
                              "font-size": "18",
                              "font-weight": "900",
                              x: "8",
                              y: "25.35"
                            }
                          },
                          [_vm._v("  ")]
                        )
                      ]
                    )
                  : _c("i", {
                      staticClass: "fas fa-check-circle fa-3x green-color"
                    })
              ],
              1
            ),
            _c("div", { staticClass: "ml-2 mt-2" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Monto Total: ")
              ]),
              _c("div", [
                _c("div", [
                  _c(
                    "span",
                    { staticClass: "color-green font-weight-bold font-22" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm._f("price")(_vm.billingTotal)) + " "
                      )
                    ]
                  ),
                  _vm._v(" / "),
                  _c("span", { staticClass: "color-secondary-6 font-16" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("price")(_vm.disbursementAmount)) +
                        " "
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ]),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          { staticClass: "row mx-auto mb-3" },
          [
            _c("icon-view", {
              staticClass: "col-12 col-md-9",
              attrs: {
                gradient: "",
                icon: "fa fa-dollar-sign",
                "icon-background": "#FF7058",
                "icon-color": "#fff",
                title: "Adjudicación por Cifra de Cuenta"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row mb-3 bg-secondary-13 pt-3 ml-2 rounded" },
          [
            _c(
              "div",
              { staticClass: "col-12 py-0 px-2" },
              [
                _c("div", { staticClass: "row px-4" }, [
                  _c(
                    "div",
                    { staticClass: "col-3 d-flex align-items-center" },
                    [
                      _vm._m(0),
                      _c(
                        "span",
                        {
                          staticClass:
                            "color-gray-6 font-16 font-weight-normal mr-2"
                        },
                        [_vm._v(" Número de Voucher: ")]
                      ),
                      _vm.canManuallySetVoucherId &&
                      _vm.disbursementInfo.requireVoucherNumber &&
                      !_vm.disbursementInfo.voucherNumber
                        ? _c(
                            "span",
                            [
                              _c(
                                "validation-observer",
                                {
                                  ref: "voucherNumberRef",
                                  attrs: { novalidate: "" }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-input", {
                                                staticClass:
                                                  "custom-input__extended w-100",
                                                attrs: {
                                                  "custom-error-msg":
                                                    "El voucher es requerido.",
                                                  error: errors[0]
                                                },
                                                model: {
                                                  value: _vm.voucherNumber,
                                                  callback: function($$v) {
                                                    _vm.voucherNumber = $$v
                                                  },
                                                  expression: "voucherNumber"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      587783483
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "span",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")(
                                      _vm.disbursementInfo.voucherNumber
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col d-flex justify-content-end align-items-center"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "color-gray-6 font-16 font-weight-normal mr-2"
                        },
                        [_vm._v(" Fecha de Voucher: ")]
                      ),
                      _vm.canSetVoucherDate && _vm.canManuallySetVoucherId
                        ? _c(
                            "validation-observer",
                            {
                              ref: "voucherDateRef",
                              attrs: { novalidate: "" }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-date-picker", {
                                            attrs: {
                                              "custom-error-msg":
                                                "La fecha de voucher es requerida.",
                                              error: errors[0]
                                            },
                                            model: {
                                              value:
                                                _vm.disbursementInfo
                                                  .voucherDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.disbursementInfo,
                                                  "voucherDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "disbursementInfo.voucherDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4118555272
                                )
                              })
                            ],
                            1
                          )
                        : _c(
                            "span",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.disbursementInfo.voucherDate
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col d-flex justify-content-end" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-end p-0"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-gray-6 font-16 font-weight-normal mr-3"
                          },
                          [_vm._v(" Número de Pago: ")]
                        ),
                        _vm.isSentToBusinessStatus &&
                        _vm.canManuallySetVoucherId
                          ? _c(
                              "span",
                              [
                                _c(
                                  "validation-observer",
                                  {
                                    ref: "paymentIdFormRef",
                                    attrs: { novalidate: "" }
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  staticClass:
                                                    "custom-input__extended mr-2",
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "El número de pago es requerido.",
                                                    error: errors[0],
                                                    maxlength: "50"
                                                  },
                                                  model: {
                                                    value: _vm.paymentId,
                                                    callback: function($$v) {
                                                      _vm.paymentId = $$v
                                                    },
                                                    expression: "paymentId"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3559261254
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-normal mr-5"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("empty")(_vm.paymentId)) +
                                    " "
                                )
                              ]
                            )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col d-flex justify-content-end align-items-center"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "color-gray-6 font-16 font-weight-normal mr-2"
                        },
                        [_vm._v(" Fecha de Pago: ")]
                      ),
                      _vm.isEnviadoAFinanzasStatus &&
                      _vm.canManuallySetVoucherId
                        ? _c(
                            "validation-observer",
                            {
                              ref: "paymentDateRef",
                              attrs: { novalidate: "" }
                            },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-date-picker", {
                                            attrs: {
                                              "custom-error-msg":
                                                "La fecha de pago es requerida.",
                                              error: errors[0]
                                            },
                                            model: {
                                              value:
                                                _vm.disbursementInfo
                                                  .paymentDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.disbursementInfo,
                                                  "paymentDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "disbursementInfo.paymentDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3275228811
                                )
                              })
                            ],
                            1
                          )
                        : _c(
                            "span",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.disbursementInfo.paymentDate
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-auto d-flex align-items-end justify-content-end"
                    },
                    [
                      _vm.disbursementInfo.voucherNumber && _vm.isDirectPayment
                        ? _c("action-button", {
                            staticClass:
                              "d-flex justify-content-center align-items-center ml-3",
                            attrs: {
                              i: "fas fa-redo-alt",
                              variant: "outline-success"
                            },
                            on: { click: _vm.onUpdatePurchaseOrderHandler }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _c("hr"),
                _vm.isPurchaseOrdersEmpty
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-12 bg-white rounded p-4 d-flex align-items-center justify-content-center"
                      },
                      [
                        _c("action-button", {
                          staticClass: "border w-40 btn",
                          attrs: {
                            id: "btn-insert-row-number",
                            i: "fas fa-file-plus color-primary-1",
                            text: "Presione aquí para añadir cifra"
                          },
                          on: { click: _vm.openNewDigitForm }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._l(
                  _vm.disbursementInfo.disbursementPurchaseOrderNumbers,
                  function(digit, index) {
                    return _c(
                      "div",
                      {
                        key: `payment_list_${index}`,
                        staticClass: "bg-white rounded py-3 mb-3 px-3 mt-3"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-4 mt-1" }, [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v(" Número de Cifra: ")]
                            ),
                            _c("div", { staticClass: "color-black font-16" }, [
                              _vm._v(" " + _vm._s(digit.fullNumber) + " ")
                            ])
                          ]),
                          _c("div", { staticClass: "col-sm col-md-2 mt-1" }, [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v(" Número de línea: ")]
                            ),
                            _c("div", { staticClass: "color-black font-16" }, [
                              _vm._v(" " + _vm._s(digit.lineNumber) + " ")
                            ])
                          ]),
                          _c("div", { staticClass: "col-sm col-md-2 mt-1" }, [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v(" Tipo de Cifra: ")]
                            ),
                            _c("div", { staticClass: "color-black font-16" }, [
                              _vm._v(" " + _vm._s(digit.digitType) + " ")
                            ])
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm col-md-2 mt-3 mt-md-1 mt-sm-3"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "color-secondary-6 font-14" },
                                [_vm._v(" Monto: ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "color-black font-16 font-14" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("price")(digit.amount)) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm col-md-2 mt-1 d-flex justify-content-end"
                            },
                            [
                              _vm.isApprovedStatus || _vm.isInPaymentProcess
                                ? _c(
                                    "action-button",
                                    {
                                      attrs: {
                                        id: "btn-remove-digit",
                                        i: "fas fa-times-circle",
                                        variant:
                                          "outline-danger btn-cancel danger m-2 pr-4"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteDigit(digit)
                                        }
                                      }
                                    },
                                    [_vm._v(" Eliminar ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }
                ),
                _vm.disbursementInfo.addDigitForm &&
                !_vm.disbursementInfo.voucherNumber
                  ? _c(
                      "div",
                      { staticClass: "row mt-3 bg-white rounded p-2 mx-0" },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "validation-observer",
                                {
                                  ref: "disbursementRequestPaymentResultRef",
                                  attrs: { novalidate: "", tag: "form" }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14"
                                          },
                                          [_vm._v(" Número de Cifra: ")]
                                        ),
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-drop-down", {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        clearable: false,
                                                        "custom-error-msg":
                                                          "La cifra de cuenta es requerida.",
                                                        error: errors[0],
                                                        fieldkey: "id",
                                                        fieldname: "name",
                                                        options:
                                                          _vm.digitNumbers,
                                                        placeholder:
                                                          "Seleccione"
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.onPurchaseOrderChange
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.value
                                                            .purchaseOrderNumber,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.value,
                                                            "purchaseOrderNumber",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "value.purchaseOrderNumber"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1686916743
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-sm col-md-2 mt-1" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14"
                                          },
                                          [_vm._v(" Número de línea: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "color-black font-16"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(
                                                    _vm.lineNumber
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-sm col-md-3 mt-1" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14"
                                          },
                                          [_vm._v(" Tipo de Cifra: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "color-black font-16"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(_vm.digitType)
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm col-md-3 mt-3 mt-md-1 mt-sm-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14"
                                          },
                                          [_vm._v(" Monto: ")]
                                        ),
                                        _c("validation-provider", {
                                          attrs: {
                                            "custom-messages": {
                                              required:
                                                "El monto es requerido.",
                                              greaterThanZero:
                                                "El monto debe ser mayor de 0."
                                            },
                                            rules: "required|greaterThanZero"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group mb-3"
                                                      },
                                                      [
                                                        _c("custom-input", {
                                                          staticClass:
                                                            "custom-input__extended w-100",
                                                          attrs: {
                                                            "custom-error-msg":
                                                              "La cantidad debe ser mayor a 0.",
                                                            error: errors[0],
                                                            "mask-type":
                                                              "Money",
                                                            "prepend-icon":
                                                              "fa fa-dollar-sign",
                                                            "prepend-icon-left": true,
                                                            "prepend-icon-type":
                                                              "success"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.value.amount,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.value,
                                                                "amount",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "value.amount"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3093516618
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-12 mt-1 d-flex align-items-center justify-content-end"
                                      },
                                      [
                                        _c(
                                          "action-button",
                                          {
                                            attrs: {
                                              id: "btn-cancel-digit",
                                              i: "fas fa-times-circle",
                                              variant:
                                                "outline-danger btn-cancel danger  m-2 pl-4 pr-4"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.cancelDigit()
                                              }
                                            }
                                          },
                                          [_vm._v(" Cancelar ")]
                                        ),
                                        _c(
                                          "action-button",
                                          {
                                            attrs: {
                                              id: "btn-save-digit",
                                              i: "fas fa-save",
                                              variant: "success m-2 pl-4 pr-4"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveDigit()
                                              }
                                            }
                                          },
                                          [_vm._v(" Guardar ")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.disbursementInfo.disbursementPurchaseOrderNumbers.length >
                  0 &&
                !_vm.disbursementInfo.addDigitForm &&
                (_vm.isApprovedStatus || _vm.isInPaymentProcess)
                  ? _c(
                      "div",
                      { staticClass: "text-right mt-2" },
                      [
                        _c("action-button", {
                          attrs: {
                            id: "btn-add-digit",
                            i: "fas fa-file-plus",
                            text: "Añadir Cifra",
                            variant: "success px-3"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openNewDigitForm()
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ]),
    _vm.hasPurchaseOrders
      ? _c(
          "div",
          [
            _c("section-title", {
              attrs: { "has-line": true, title: "Documentos" }
            }),
            _vm.determinationId == 3
              ? _c(
                  "custom-callout",
                  { attrs: { "has-border": false, "has-toggle": false } },
                  [
                    _c("div", { staticClass: "row col-12 pr-0" }, [
                      _c("div", { staticClass: "row col-8" }, [
                        _c("div", { staticClass: "row col-12 col-md-6" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "span",
                              {
                                staticClass: "data-title d-block border-mobile"
                              },
                              [_vm._v(" Documento: ")]
                            ),
                            _c("span", { staticClass: "font-16 color-black" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")("Carta de Autorización")
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-4 d-flex align-items-center justify-content-end"
                        },
                        [
                          _c("action-button", {
                            staticClass:
                              "ab-btn px-2 download-btn ab-btn-success",
                            attrs: { i: "fas fa-download mx-1" },
                            on: { click: _vm.onDownloadRefundReport }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "validation-observer",
              { ref: "paymentDocumentFormRef" },
              _vm._l(_vm.documents, function(document, index) {
                return _c("validation-provider", {
                  key: `document-${index}`,
                  attrs: {
                    "custom-messages": {
                      required_if: _vm.docValidationMessage(document)
                    },
                    disabled: !_vm.isReimbursementCertification(
                      document.documentTypeId
                    )
                      ? "disabled"
                      : false,
                    rules: {
                      required_if:
                        !document.documentId &&
                        !_vm.isDisbursementCertificationExceptionYear
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("DocumentView", {
                              attrs: {
                                "can-add-document":
                                  _vm.isReimbursementCertification(
                                    document.documentTypeId
                                  ) &&
                                  (_vm.isApprovedStatus ||
                                    _vm.isInPaymentProcess),
                                "document-file-name": document.documentFilename,
                                "document-id": document.documentId,
                                "document-name": document.documentTypeName,
                                "document-type-id": document.documentTypeId,
                                "request-id": _vm.requestId,
                                "show-replace-button":
                                  _vm.isReimbursementCertification(
                                    document.documentTypeId
                                  ) &&
                                  (_vm.isApprovedStatus ||
                                    _vm.isInPaymentProcess)
                              },
                              on: {
                                "on-document-added": docValue =>
                                  _vm.onDocumentAddedHandler(document, docValue)
                              }
                            }),
                            errors[0] && errors[0].length > 0
                              ? _c("custom-error", {
                                  attrs: {
                                    message: errors[0],
                                    variant: "no-border"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "fa-stack fa-1x color-green font-14 mr-3" },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fas fa-usd-square fa-stack-1x fa-inverse" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }